import axios from 'axios';

import {
  axiosHeaderV2,
  getV2RootUrl,
  publicAxiosHeaderV2
} from 'common/helpers/apiHelper';

export const listClubMemberships = (customerId, queryString) => {
  if (queryString) {
    return axios.get(
      `${getV2RootUrl()}/customer/${customerId}/club-membership?${queryString}`,
      axiosHeaderV2()
    );
  }
  return axios.get(
    `${getV2RootUrl()}/customer/${customerId}/club-membership`,
    axiosHeaderV2()
  );
};

export const getClubMembership = (clubMembershipId, customerId) => {
  if (!customerId) {
    return axios.get(
      `${getV2RootUrl()}/club-membership/${clubMembershipId}/limited`,
      publicAxiosHeaderV2()
    );
  }
  return axios.get(
    `${getV2RootUrl()}/customer/${customerId}/club-membership/${clubMembershipId}`,
    axiosHeaderV2()
  );
};

export const editClubMembership = (customerId, clubMembershipId, data) =>
  axios.put(
    `${getV2RootUrl()}/customer/${customerId}/club-membership/${clubMembershipId}`,
    data,
    axiosHeaderV2()
  );

export const cancelClubMembership = (customerId, clubMembershipId, data) =>
  axios.put(
    `${getV2RootUrl()}/customer/${customerId}/club-membership/${clubMembershipId}/cancel`,
    data,
    axiosHeaderV2()
  );

export const addClubMembershipHold = (customerId, clubMembershipId, data) =>
  axios.post(
    `${getV2RootUrl()}/customer/${customerId}/club-membership/${clubMembershipId}/on-hold`,
    data,
    axiosHeaderV2()
  );

export const editClubMembershipHold = (
  customerId,
  clubMembershipId,
  id,
  data
) =>
  axios.put(
    `${getV2RootUrl()}/customer/${customerId}/club-membership/${clubMembershipId}/on-hold/${id}`,
    data,
    axiosHeaderV2()
  );

export const getNextShipment = (customerId, clubMembershipId) => {
  if (!customerId) {
    return axios.get(
      `${getV2RootUrl()}/club-membership/${clubMembershipId}/next-club-shipment/limited`,
      axiosHeaderV2()
    );
  }
  return axios.get(
    `${getV2RootUrl()}/customer/${customerId}/club-membership/${clubMembershipId}/next-club-shipment`,
    axiosHeaderV2()
  );
};
